import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-black text-2xl" }, "사용량", -1)
const _hoisted_3 = { class: "flex mt-8 items-baseline" }
const _hoisted_4 = { class: "shrink-0 w-44" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl mr-2" }, " 이미지 ", -1)
const _hoisted_6 = { class: "flex mt-4 items-baseline" }
const _hoisted_7 = { class: "shrink-0 w-44" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl mr-2" }, " 동영상 ", -1)
const _hoisted_9 = { class: "flex gap-4 mt-12" }
const _hoisted_10 = { class: "flex-1 flex-col" }
const _hoisted_11 = { class: "p-4 flex justify-between items-center text-blue" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "이미지 변환 결과물", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "더보기", -1)
const _hoisted_14 = { class: "flex-1 flex-col" }
const _hoisted_15 = { class: "p-4 flex justify-between items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl" }, "동영상 변환 결과물", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "더보기", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", null, _toDisplayString(_ctx.userData.imageCurrentUsageCount) + " / " + _toDisplayString(_ctx.userData.imageMaxUsageCount) + " 장 ", 1)
      ]),
      _createVNode(_component_a_progress, {
        percent: 
          (_ctx.userData.imageCurrentUsageCount / _ctx.userData.imageMaxUsageCount) * 100
        ,
        "show-info": false,
        "stroke-color": "rgb(74, 222, 128)",
        class: "self-center"
      }, null, 8, ["percent"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_ctx.getHHMM(_ctx.userData.videoCurrentUsageLength)) + " / " + _toDisplayString(_ctx.getHHMM(_ctx.userData.videoMaxUsageLength)), 1)
      ]),
      _createVNode(_component_a_progress, {
        class: "flex self-center",
        percent: 
          (_ctx.userData.videoCurrentUsageLength / _ctx.userData.videoMaxUsageLength) *
          100
        ,
        "show-info": false,
        "stroke-color": "rgb(59, 130, 246)"
      }, null, 8, ["percent"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", {
            class: "flex items-center cursor-pointer text-gray-600 hover:text-blue-500 hover:font-bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRoute('images')))
          }, [
            _createVNode(_component_PlusOutlined, { class: "mr-1 text-gree" }),
            _hoisted_13
          ])
        ]),
        _createVNode(_component_Table, {
          list: _ctx.state.imageRows
        }, null, 8, ["list"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", {
            class: "flex items-center cursor-pointer text-gray-600 hover:text-blue-500 hover:font-bold",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRoute('videos')))
          }, [
            _createVNode(_component_PlusOutlined, { class: "mr-1" }),
            _hoisted_17
          ])
        ]),
        _createVNode(_component_Table, {
          "media-type": "video",
          list: _ctx.state.videoRows
        }, null, 8, ["list"])
      ])
    ])
  ]))
}